import { Link } from "react-router-dom";
import VideoCard from "@/components/base/VideoCard";
import type { Video } from "@/mocks/videos";

interface VideoSectionProps {
  title: string;
  subtitle?: string;
  videos: Video[];
  viewAllLink?: string;
  viewAllLabel?: string;
}

export default function VideoSection({ title, subtitle, videos, viewAllLink, viewAllLabel }: VideoSectionProps) {
  return (
    <section className="py-8 md:py-12">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold" style={{ fontFamily: "var(--font-heading)", color: "oklch(var(--foreground-900))" }}>
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
          )}
        </div>
        {viewAllLink && (
          <Link
            to={viewAllLink}
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap transition-colors"
          >
            {viewAllLabel || "查看全部"}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3 md:gap-4">
        {videos.map((video) => (
          <VideoCard key={video.id} video={video} />
        ))}
      </div>
    </section>
  );
}